import { IsEnum, IsNumber, IsOptional, IsString, Min } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { FryerOilRecordType } from './fryer-oil-record-type.enum';

export class CorrectFryerOilRecordDto {
  @IsEnum(FryerOilRecordType)
  recordType!: FryerOilRecordType;

  @IsNumber()
  @IsOptional()
  @Min(0)
  tpiValue?: number;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  notes?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  reason?: string;
}
